import React from 'react';
import Reveal from './Reveal';

/**
 * Stagger simple: envuelve cada hijo directo en un Reveal
 * con delay incremental. Ideal para: título -> subtítulo -> contenido.
 */
export default function Stagger({
  children,
  baseDelay = 0,
  step = 90,
  variants = ['fade-up'],
  distance = 18,
}) {
  const items = React.Children.toArray(children).filter(Boolean);

  return (
    <>
      {items.map((child, i) => (
        <Reveal
          key={child.key ?? i}
          delay={baseDelay + i * step}
          variant={variants[i % variants.length]}
          distance={distance}
        >
          {child}
        </Reveal>
      ))}
    </>
  );
}
